(function () {
  function normalizeText(value) {
    return (value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getItemSearchText(item) {
    var question = item.querySelector('.kewe-help-center__question');
    var answer = item.querySelector('.kewe-help-center__answer');

    return normalizeText(
      [question ? question.textContent : '', answer ? answer.textContent : ''].join(' ')
    );
  }

  function updateCategoryNavigation(section, showAllLinks) {
    var navLinks = Array.prototype.slice.call(section.querySelectorAll('.kewe-help-center__nav-link'));

    navLinks.forEach(function (link) {
      if (showAllLinks) {
        link.hidden = false;
        return;
      }

      var targetId = (link.getAttribute('href') || '').replace(/^#/, '');
      var target = targetId ? section.querySelector('#' + targetId) : null;
      var targetCategory = target
        ? target.closest('[data-kewe-help-center-category]')
        : null;

      var showLink = targetCategory ? !targetCategory.hidden : false;

      link.hidden = !showLink;
    });
  }

  function updateHelpCenter(section, query) {
    var clearButton = section.querySelector('[data-kewe-help-center-clear]');
    var status = section.querySelector('[data-kewe-help-center-status]');
    var emptyState = section.querySelector('[data-kewe-help-center-empty]');
    var categories = Array.prototype.slice.call(section.querySelectorAll('[data-kewe-help-center-category]'));
    var normalizedQuery = normalizeText(query);
    var visibleCategoryCount = 0;
    var visibleItemCount = 0;

    section.setAttribute('data-kewe-help-center-query', normalizedQuery);

    categories.forEach(function (category) {
      var items = Array.prototype.slice.call(category.querySelectorAll('[data-kewe-help-center-item]'));
      var matchedItems = 0;

      items.forEach(function (item) {
        var itemText = getItemSearchText(item);
        var isMatch = !normalizedQuery || itemText.indexOf(normalizedQuery) !== -1;

        item.hidden = !isMatch;

        if (!isMatch) {
          item.removeAttribute('open');
          return;
        }

        matchedItems += 1;
        visibleItemCount += 1;
      });

      var showCategory = matchedItems > 0 || (!normalizedQuery && items.length > 0);
      category.hidden = !showCategory;

      if (showCategory) {
        visibleCategoryCount += 1;
      }
    });

    var showAllNavLinks = normalizedQuery && visibleItemCount === 0;
    updateCategoryNavigation(section, showAllNavLinks);

    if (clearButton) {
      clearButton.hidden = !normalizedQuery;
    }

    if (emptyState) {
      emptyState.hidden = visibleItemCount > 0;
    }

    if (!status) {
      return;
    }

    if (!normalizedQuery) {
      status.textContent = 'Browse by category or search across the full FAQ.';
      return;
    }

    if (visibleItemCount === 0) {
      status.textContent = 'No results for "' + normalizedQuery + '".';
      return;
    }

    status.textContent =
      visibleItemCount +
      ' result' +
      (visibleItemCount === 1 ? '' : 's') +
      ' across ' +
      visibleCategoryCount +
      ' categor' +
      (visibleCategoryCount === 1 ? 'y' : 'ies') +
      '.';
  }

  function initializeHelpCenter(section) {
    if (!section || section.dataset.keweHelpCenterInitialized === 'true') {
      return;
    }

    var form = section.querySelector('[data-kewe-help-center-form]');
    var searchInput = section.querySelector('[data-kewe-help-center-search]');
    var clearButton = section.querySelector('[data-kewe-help-center-clear]');

    if (form && searchInput) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        updateHelpCenter(section, searchInput.value);
      });
    }

    if (clearButton && searchInput) {
      clearButton.addEventListener('click', function () {
        searchInput.value = '';
        searchInput.focus();
        updateHelpCenter(section, '');
      });
    }

    section.dataset.keweHelpCenterInitialized = 'true';
    updateHelpCenter(section, '');
  }

  function initializeAllHelpCenters(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var sections = scope.querySelectorAll('[data-kewe-help-center]');

    sections.forEach(function (section) {
      initializeHelpCenter(section);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initializeAllHelpCenters(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllHelpCenters(event.target);
  });
})();
